export enum SalesTaxRulesetPredefinedTag {
  Exempt = '2014_exempt',
  Goods = '2014_goods',
  Services = '2014_services',
}
